import React from "react";
import { withStyles } from "@material-ui/core";

import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import CloseIcon from "./CloseIcon";

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";
import { copyTextToClipboard } from "../../utils/copyToClipboard";

const styles = {
  link: {
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  dialogPaper: {
    minWidth: "600px",
    maxWidth: "calc(100vw - 100px)",
  },
  closeIconItem: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "12px",
  },
  contentContainer: {
    maxHeight: "calc(100vh - 147px)",
    maxWidth: "calc(100vw - 100px)",
    overflow: "auto",
    padding: "12px",
  },
};

const JsonViewerDialog = (props) => {
  const { classes, value } = props;
  const [open, setOpen] = React.useState(false);

  const jsonValue = JSON.stringify(JSON.parse(value), null, 3);

  return (
    <>
      <Box style={{ cursor: "pointer" }} onClick={() => setOpen(true)}>
        <pre>{jsonValue}</pre>
      </Box>
      <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
        <Grid container direction="column" id="json-viewer">
          <Grid item>
            <Grid container alignItems="center">
              <img
                src={images.copyIconColored}
                alt="copy"
                style={{ cursor: "pointer", padding: "12px" }}
                onClick={() => copyTextToClipboard(jsonValue, "json-viewer")}
              />
              <Grid item xs className={classes.closeIconItem}>
                <CloseIcon closeFunction={() => setOpen(false)} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item className={classes.contentContainer}>
            <pre>{jsonValue}</pre>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default withStyles(styles)(JsonViewerDialog);
